import { Button, Tooltip } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { ReactNode } from "react";

interface TooltipButtonPropsType {
  placement: TooltipPlacement | undefined;
  title?: string;
  handleOnClick?: (() => void) | undefined;
  icon?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  size?: "small" | "middle" | "large";
  variant?: "default" | "delete";
}

export default function TooltipButton(props: TooltipButtonPropsType): React.ReactElement {
  const {
    placement,
    title,
    handleOnClick,
    icon: Icon,
    disabled = false,
    loading = false,
    size = "small",
    variant = "default",
  } = props;

  return (
    <Tooltip placement={placement} title={disabled ? "" : title}>
      <Button
        shape="circle"
        className={`tooltip-button ${variant === "delete" ? "delete" : ""}`}
        onClick={handleOnClick}
        size={size}
        disabled={disabled}
        loading={loading}
        icon={Icon && <span className="tooltip-button-icon">{Icon}</span>}
      />
    </Tooltip>
  );
}
